export default __webpack_public_path__ + "static/Крысиные бега_5-7020b0e4aba05d7e2ea8aff4c4f64a97.jpg";